import Loading from './Loading';
import LoadingTable from './LoadingTable';

export default Loading;
export { LoadingTable };



// WEBPACK FOOTER //
// ./src/components/Loading/index.jsx